import { encryptStorage } from "../../../../constants/EncryptStorage";
import { ApiLuggage } from "../api/ApiLuggage";

export const addLuggage = async (addData) => {
  try {
    const data = await ApiLuggage().addLuggage(
      {
        ...addData
      }
    );

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const updateLuggage = async (updateData) => {
  try {
    const data = await ApiLuggage().updateLuggage(
      {
        ...updateData
      }
    );

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const updateLuggageStatus = async (updateData) => {
  try {
    const data = await ApiLuggage().updateLuggageStatus(
      {
        ...updateData
      }
    );

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getLuggages = async () => {
  try {
    const data  = await ApiLuggage().getLuggage();

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getNewLuggages = async ({ pageIndex, pageSize, search, sortBy, sortDir } = {}) => {
  try {
    const data  = await ApiLuggage().getLuggages(pageIndex, pageSize, search, sortBy, sortDir);

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getLuggageById = async (id) => {
  try {
    const data  = await ApiLuggage().getLuggageById(id);

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getCarrierLuggages = async () => {
  try {
    const carrierId = encryptStorage.getItem("userId");
    const data  = await ApiLuggage().getCarrierLuggage(carrierId);

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const deleteLuggage = async (luggageId) => {
  try {
    // Make the DELETE request to delete the user
    const data = await ApiLuggage().deleteLuggage(luggageId);

    if (data.success) {
      return { success: true, message: data.message };
    } else {
      return { success: false, message: data.errors };
    }
  } catch (error) {
    console.error("Error deleting user:", error);
    return { success: false, message: "An error occurred while deleting the user" };
  }
};

export const deleteBulkLuggages = async (luggageIds) => {
  try {
    // Make the DELETE request to delete the user
    const data = await ApiLuggage().bulkDeleteLuggages(luggageIds);

    if (data.success) {
      return { success: true, message: data.message };
    } else {
      return { success: false, message: data.errors };
    }
  } catch (error) {
    console.error("Error deleting user:", error);
    return { success: false, message: "An error occurred while deleting the user" };
  }
};